import { ReactNode } from 'react';
import type { QuestionSettings } from '~/lib/Questions/Questions.types';
import { isAdminApp } from '~/public/lib/PageHelpers';
import { FormPart, part } from '~/lib/FormCssApi';

type QuestionLabelProps = {
    label?: ReactNode;
    settings?: QuestionSettings;
    className?: string;
};

const QuestionLabel = ({ label, settings, className }: QuestionLabelProps) => {
    const isAdmin =
        isAdminApp() &&
        !document.getElementsByClassName('is-designing-form')?.length;
    return (
        <div
            {...part(FormPart.LABEL)}
            className={`${isAdmin ? 'input-label' : 'text-gray-700 text-base tracking-[0.25px]'}  mb-1 ${className ?? ''}`}
        >
            {label}
            {!!settings?.required && label && (
                <span
                    {...part(FormPart.REQUIRED_MARKER)}
                    className="ml-1 text-red-600"
                >
                    *
                </span>
            )}
        </div>
    );
};

export default QuestionLabel;
